import { ErpDiv, ErpP } from "@/components/erp";
import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const PageLoader: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ErpDiv className="flex flex-col items-center justify-center w-full min-h-[60vh] gap-4">
      <ErpDiv className="relative flex items-center justify-center w-16 h-16 rounded-full bg-primary/10">
        <Loader2 size={32} className="animate-spin text-indigo-600 absolute" />
      </ErpDiv>
      <ErpP className="text-muted-foreground animate-pulse font-medium">{t('Loading')}...</ErpP>
    </ErpDiv>
  );
};

export default PageLoader;
